import "@react-pdf-viewer/core/lib/styles/index.css";
import React, { useEffect, useState } from "react";
import CancelIcon from "../../assets/images/cancel_icon.svg";
import ImageScaleIcon from "../../assets/images/image_scale_icon.svg";
import "../css/DocumentViewer.css";

const DocumentViewer = ({ documentUrl, documentName, onClose }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingTimeout, setLoadingTimeout] = useState(null);
  const documentType = documentName.split(".").pop().toLowerCase();
  const [pdfKey, setPdfKey] = useState(0);

  useEffect(() => {
    setIsLoading(true);

    if (loadingTimeout) {
      clearTimeout(loadingTimeout);
    }

    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    setLoadingTimeout(timeout);

    return () => {
      if (loadingTimeout) {
        clearTimeout(loadingTimeout);
      }
    };
  }, [documentUrl]);

  const handleLoad = () => {
    if (loadingTimeout) {
      clearTimeout(loadingTimeout);
    }
    setIsLoading(false);
  };

  const handleError = () => {
    if (loadingTimeout) {
      clearTimeout(loadingTimeout);
    }
    setIsLoading(false);
  };

  const toggleFullScreen = () => {
    setPdfKey(prevKey => prevKey + 1);
    setIsFullScreen(!isFullScreen);
  };

  const handleClickOutside = (e) => {
    if (e.target.classList.contains("fullscreen-overlay")) {
      setIsFullScreen(false);
    }
  };

  const renderDocument = () => {
    switch (documentType) {
      case "jpg":
      case "jpeg":
      case "png":
        return (
          <div className={isFullScreen ? "fullscreen-overlay" : ""} onClick={handleClickOutside}>
            <div className="document-viewer-modal">
              <div className="document-viewer-modal-icons">
                <img
                  src={ImageScaleIcon}
                  alt="Fullscreen"
                  className="document-viewer-icon"
                  onClick={toggleFullScreen}
                />
                <img
                  src={CancelIcon}
                  alt="Close"
                  className="document-viewer-icon"
                  onClick={onClose}
                />
              </div>
              <div className="document-viewer-modal-body">
                {isLoading && <div className="document-viewer-loading">Loading...</div>}
                <img
                  src={documentUrl}
                  alt="Document"
                  className={`document-viewer-modal-image ${isLoading ? "document-viewer-hidden" : ""}`}
                  onLoad={handleLoad}
                  onError={handleError}
                />
              </div>
            </div>
          </div>
        );

      case "tif":
      case "pdf":
        const viewerUrl = documentUrl.startsWith("data:")
          ? documentUrl
          : `https://docs.google.com/viewer?url=${encodeURIComponent(documentUrl)}&embedded=true&cache=false`;

        return (
          <div className={isFullScreen ? "fullscreen-overlay" : ""} onClick={handleClickOutside}>
            <div className="document-viewer-modal">
              <div className="document-viewer-modal-icons">
                <img
                  src={ImageScaleIcon}
                  alt="Fullscreen"
                  className="document-viewer-icon"
                  onClick={toggleFullScreen}
                />
                <img
                  src={CancelIcon}
                  alt="Close"
                  className="document-viewer-icon"
                  onClick={onClose}
                />
              </div>
              <div className="document-viewer-modal-body">
                {isLoading && <div className="document-viewer-loading">Loading...</div>}
                <iframe
                  key={`${documentUrl}-${pdfKey}-${isFullScreen}`}
                  src={viewerUrl}
                  className={`document-viewer-pdf-viewer ${isLoading ? "document-viewer-hidden" : ""}`}
                  width="100%"
                  height="100%"
                  title="Document Viewer"
                  onLoad={handleLoad}
                  onError={handleError}
                  frameBorder="0"
                />
              </div>
            </div>
          </div>
        );

      default:
        return <p>Unsupported file type</p>;
    }
  };

  return (
    <div className={`document-viewer ${isFullScreen ? "fullscreen" : ""}`}>
      {renderDocument()}
    </div>
  );
};

export default DocumentViewer;
